module.exports = __webpack_public_path__ + "9e282fefdc4d47ad3fdc13bd9f9086f4.pdf";